export default __webpack_public_path__ + "static/media/ic_person_collect.c373a24d.png";